/* eslint-disable */

// This file was automatically generated by @icp-sdk/bindgen@0.4.1.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import type { ActorMethod } from '@icp-sdk/core/agent';
import type { Principal } from '@icp-sdk/core/principal';
import { IDL } from '@icp-sdk/core/candid';

export interface Account {
  'owner' : Principal,
  'subaccount' : [] | [Uint8Array],
}
export interface AllocationPolicy {
  'all_in' : boolean,
  'mining_share_bps' : bigint,
  'purchases_enabled' : boolean,
  'version' : bigint,
  'native_token' : [] | [Principal],
  'screener_share_bps' : bigint,
  'pool_enabled' : boolean,
  'rounding_remainder' : string,
}
export interface BalanceSnapshot {
  'updated_at' : bigint,
  'canister_e8s' : bigint,
  'failed_accounts' : bigint,
  'canister_covered' : bigint,
  'wallet_covered' : bigint,
  'wallet_e8s' : bigint,
  'canister_accounts' : bigint,
  'combined_e8s' : bigint,
  'account_limit_reached' : boolean,
  'complete' : boolean,
  'started_at' : bigint,
  'wallet_accounts' : bigint,
}
export interface Config { 'ledger' : Principal, 'canisters' : Array<Principal> }
export interface ConfigView {
  'test_mode' : [] | [boolean],
  'slippage_bps' : bigint,
  'enabled' : boolean,
  'configured' : boolean,
  'ledger' : [] | [Principal],
  'factory' : [] | [Principal],
  'market' : [] | [Principal],
  'payment_ledger' : [] | [Principal],
}
export interface Config__1 {
  'test_mode' : boolean,
  'enabled' : boolean,
  'ledger' : Principal,
  'factory' : Principal,
}
export interface Consumed {
  'memory' : bigint,
  'canister_creation' : bigint,
  'burned_cycles' : bigint,
  'http_outcalls' : bigint,
  'instructions' : bigint,
  'uninstall' : bigint,
  'ingress_induction' : bigint,
  'request_and_response_transmission' : bigint,
  'compute_allocation' : bigint,
}
export interface CycleReport {
  'sampled_at' : bigint,
  'canister' : Principal,
  'consumed' : Consumed,
}
export interface CycleSummary {
  'newest_sample_at' : [] | [bigint],
  'source' : string,
  'oldest_sample_at' : [] | [bigint],
  'complete' : boolean,
  'cycles' : [] | [bigint],
  'stale' : boolean,
  'expected_canisters' : bigint,
  'covered_canisters' : bigint,
}
export interface Fields {
  'x' : string,
  'description' : string,
  'website' : string,
  'discord' : string,
  'telegram' : string,
}
export interface FieldsV2 {
  'x' : string,
  'banner' : string,
  'description' : string,
  'website' : string,
  'discord' : string,
  'telegram' : string,
}
export interface FieldsV3 {
  'x' : string,
  'roadmap' : Array<Milestone>,
  'about' : string,
  'banner' : string,
  'description' : string,
  'website' : string,
  'discord' : string,
  'telegram' : string,
}
export interface Fill {
  'out' : bigint,
  'base_net' : bigint,
  'completes' : boolean,
  'fee_platform' : bigint,
  'fee_creator' : bigint,
  'refund' : bigint,
}
export interface Image {
  'height' : bigint,
  'data' : Uint8Array,
  'content_type' : string,
  'width' : bigint,
}
export interface Job {
  'purchase_block' : [] | [bigint],
  'last_error' : [] | [string],
  'status' : State,
  'allocation_e8s' : bigint,
  'updated_at' : bigint,
  'test_mode' : boolean,
  'spent_e8s' : bigint,
  'purchased_tokens' : [] | [bigint],
  'budget_e8s' : bigint,
  'native_token' : [] | [Principal],
  'ledger' : Principal,
  'factory' : Principal,
  'quote_id' : bigint,
  'paid_at' : bigint,
  'market' : Principal,
  'receipt_block' : bigint,
  'revision' : bigint,
}
export interface Job__1 {
  'rig' : [] | [Principal],
  'last_error' : [] | [string],
  'status' : State__1,
  'allocation_e8s' : bigint,
  'approval_at' : [] | [bigint],
  'updated_at' : bigint,
  'approval_expires_at' : [] | [bigint],
  'test_mode' : boolean,
  'available_tokens' : [] | [bigint],
  'minimum_e8s' : [] | [bigint],
  'approval_fee_spent' : boolean,
  'spawn_at' : [] | [bigint],
  'budget_e8s' : bigint,
  'ledger_fee_e8s' : bigint,
  'ledger' : Principal,
  'source_pool' : [] | [Principal],
  'fuel_e8s' : bigint,
  'factory' : Principal,
  'rewards' : [] | [bigint],
  'quote_id' : bigint,
  'paid_at' : bigint,
  'graduated' : boolean,
  'market' : Principal,
  'power' : number,
  'receipt_block' : bigint,
  'revision' : bigint,
  'locked_rewards' : [] | [bigint],
  'rigs_before' : Array<Principal>,
  'token_ledger' : [] | [Principal],
  'approval_block' : [] | [bigint],
}
export interface MarketStatus {
  'allocated_e8s' : bigint,
  'jobs' : Array<Job>,
  'purchases_enabled' : boolean,
  'native_token' : [] | [Principal],
  'reserved_e8s' : bigint,
  'acquired_tokens' : [] | [bigint],
  'pool_enabled' : boolean,
  'market' : Principal,
}
export interface MarketStatus__1 {
  'allocated_e8s' : bigint,
  'jobs' : Array<Job__1>,
  'rigs' : Array<Principal>,
  'native_token' : [] | [Principal],
  'reserved_e8s' : bigint,
  'pool_enabled' : boolean,
  'market' : Principal,
}
export interface Milestone {
  'status' : { 'in_progress' : null } |
    { 'completed' : null } |
    { 'planned' : null },
  'title' : string,
  'description' : string,
  'target_date' : string,
}
export interface MiningSummary {
  'covered_rigs' : bigint,
  'refreshing' : boolean,
  'updated_at' : [] | [bigint],
  'source' : string,
  'rigs' : bigint,
  'error' : [] | [string],
  'complete' : boolean,
  'cycles' : [] | [bigint],
  'stale' : boolean,
  'limit_reached' : boolean,
}
export interface Page { 'total' : bigint, 'items' : Array<View> }
export type Payout = { 'Queued' : { 'id' : bigint } } |
  { 'Sent' : { 'block' : bigint } };
export interface Policy {
  'all_in' : boolean,
  'enabled' : boolean,
  'native_token' : [] | [Principal],
  'pool_enabled' : boolean,
  'share_bps' : bigint,
  'power' : number,
}
export interface Profile {
  'receipt' : Receipt,
  'fields' : Fields,
  'market' : Principal,
}
export interface ProfileStatus {
  'updated_at' : [] | [bigint],
  'has_profile' : boolean,
  'receipt' : [] | [Receipt],
  'pending' : boolean,
  'test_mode' : [] | [boolean],
  'publisher' : [] | [Principal],
  'paid' : boolean,
  'next_usd_cents' : bigint,
  'market' : Principal,
  'revision' : bigint,
}
export interface ProfileV2 {
  'receipt' : Receipt,
  'fields' : FieldsV2,
  'market' : Principal,
}
export interface ProfileV3 {
  'receipt' : Receipt,
  'test_mode' : [] | [boolean],
  'fields' : FieldsV3,
  'market' : Principal,
}
export type Provider = { 'plug' : null } |
  { 'internet_identity' : null };
export interface PurchaseIntent {
  'native_start' : bigint,
  'last_error' : [] | [string],
  'approval_at' : [] | [bigint],
  'native_market' : Principal,
  'approval_expires_at' : [] | [bigint],
  'default_debit_e8s' : bigint,
  'quoted_out' : bigint,
  'payment_scan_next' : bigint,
  'refunded' : boolean,
  'recipient' : Account,
  'fee_e8s' : bigint,
  'payment_start' : bigint,
  'observed_trade_id' : [] | [bigint],
  'refund_e8s' : bigint,
  'approval_fee_spent' : boolean,
  'amount_e8s' : bigint,
  'payment_block' : [] | [bigint],
  'refund_payout' : [] | [Payout],
  'observed_allowance' : [] | [bigint],
  'scan_next' : bigint,
  'payout_block' : [] | [bigint],
  'quote_id' : bigint,
  'trades_before' : [] | [bigint],
  'buy_at' : [] | [bigint],
  'buy_response' : [] | [TradeOk],
  'icp_balance' : [] | [bigint],
  'min_tokens_out' : bigint,
  'approval_block' : [] | [bigint],
  'native_balance' : [] | [bigint],
  'native_ledger' : Principal,
}
export interface Quote {
  'id' : bigint,
  'attempted_at' : [] | [bigint],
  'status' : Status,
  'test_mode' : boolean,
  'owner' : Principal,
  'rate_at' : bigint,
  'created_at' : bigint,
  'base_revision' : bigint,
  'amount_e8s' : bigint,
  'fields' : Fields,
  'icp_usd_e8s' : bigint,
  'ledger_fee_e8s' : bigint,
  'config_version' : bigint,
  'usd_cents' : bigint,
  'ledger' : Principal,
  'market' : Principal,
  'expires_at' : bigint,
}
export interface QuotePolicy {
  'test_mode' : boolean,
  'all_in' : boolean,
  'budget_e8s' : bigint,
  'ledger' : Principal,
  'factory' : Principal,
  'quote_id' : bigint,
}
export interface QuotePolicy__1 {
  'test_mode' : boolean,
  'all_in' : boolean,
  'budget_e8s' : bigint,
  'ledger' : Principal,
  'factory' : Principal,
  'quote_id' : bigint,
  'power' : number,
}
export interface QuoteV2 {
  'id' : bigint,
  'attempted_at' : [] | [bigint],
  'status' : Status,
  'test_mode' : boolean,
  'owner' : Principal,
  'rate_at' : bigint,
  'created_at' : bigint,
  'base_revision' : bigint,
  'amount_e8s' : bigint,
  'fields' : FieldsV2,
  'icp_usd_e8s' : bigint,
  'ledger_fee_e8s' : bigint,
  'config_version' : bigint,
  'usd_cents' : bigint,
  'ledger' : Principal,
  'market' : Principal,
  'expires_at' : bigint,
}
export interface QuoteV3 {
  'id' : bigint,
  'attempted_at' : [] | [bigint],
  'status' : Status,
  'test_mode' : boolean,
  'owner' : Principal,
  'rate_at' : bigint,
  'created_at' : bigint,
  'base_revision' : bigint,
  'amount_e8s' : bigint,
  'fields' : FieldsV3,
  'icp_usd_e8s' : bigint,
  'ledger_fee_e8s' : bigint,
  'config_version' : bigint,
  'usd_cents' : bigint,
  'ledger' : Principal,
  'market' : Principal,
  'expires_at' : bigint,
}
export interface ReactionConfig {
  'test_mode' : boolean,
  'generation' : bigint,
  'enabled' : boolean,
  'ledger' : Principal,
  'factory' : Principal,
  'quote_ttl_seconds' : bigint,
  'price_e8s' : bigint,
  'fee_policy' : { 'plus_network_fees' : null },
  'treasury' : Account,
}
export interface ReactionConfigInput {
  'test_mode' : boolean,
  'enabled' : boolean,
  'ledger' : Principal,
  'factory' : Principal,
}
export type ReactionKind = { 'fire' : null } |
  { 'flag' : null } |
  { 'poop' : null } |
  { 'rocket' : null };
export interface ReactionQuote {
  'id' : bigint,
  'attempted_at' : [] | [bigint],
  'status' : ReactionStatus,
  'total_debit_e8s' : bigint,
  'test_mode' : boolean,
  'owner' : Principal,
  'kind' : ReactionKind,
  'created_at' : bigint,
  'transfer_at' : [] | [bigint],
  'allowance_e8s' : bigint,
  'amount_e8s' : bigint,
  'ledger_fee_e8s' : bigint,
  'config_version' : bigint,
  'ledger' : Principal,
  'scan_next' : bigint,
  'market' : Principal,
  'expires_at' : bigint,
  'spender' : Account,
  'treasury' : Account,
  'scan_start' : bigint,
}
export interface ReactionReceipt {
  'test_mode' : boolean,
  'kind' : ReactionKind,
  'amount_e8s' : bigint,
  'ledger' : Principal,
  'paid_at' : bigint,
  'block' : bigint,
  'market' : Principal,
}
export type ReactionStatus = { 'pending' : null } |
  { 'paid' : ReactionReceipt } |
  { 'uncertain' : string } |
  { 'quoted' : null } |
  { 'failed' : string };
export interface ReactionTotals {
  'updated_at' : [] | [bigint],
  'total' : bigint,
  'test_mode' : boolean,
  'fire' : bigint,
  'flag' : bigint,
  'poop' : bigint,
  'market' : Principal,
  'rocket' : bigint,
}
export interface Receipt {
  'publisher' : Principal,
  'amount_e8s' : bigint,
  'usd_cents' : bigint,
  'ledger' : Principal,
  'paid_at' : bigint,
  'block' : bigint,
  'revision' : bigint,
}
export interface Request {
  'url' : string,
  'method' : string,
  'body' : Uint8Array,
  'headers' : Array<[string, string]>,
  'certificate_version' : [] | [number],
}
export interface Response {
  'body' : Uint8Array,
  'headers' : Array<[string, string]>,
  'upgrade' : [] | [boolean],
  'streaming_strategy' : [] | [
    { 'Callback' : { 'token' : Uint8Array, 'callback' : [Principal, string] } }
  ],
  'status_code' : number,
}
export type Result = { 'ok' : bigint } |
  { 'err' : string };
export type Result_1 = { 'ok' : View } |
  { 'err' : string };
export type Result_2 = { 'ok' : null } |
  { 'err' : string };
export type Result_3 = { 'ok' : ReactionQuote } |
  { 'err' : string };
export type Result_4 = { 'ok' : Receipt } |
  { 'err' : string };
export type Result_5 = { 'ok' : QuoteV3 } |
  { 'err' : string };
export type Result_6 = { 'ok' : QuoteV2 } |
  { 'err' : string };
export type Result_7 = { 'ok' : Quote } |
  { 'err' : string };
export type Sort = { 'top' : null } |
  { 'newest' : null };
export type State = { 'waiting_for_screener' : null } |
  { 'held' : string } |
  { 'approval_uncertain' : null } |
  { 'holding' : null } |
  { 'queued' : null } |
  { 'purchase_uncertain' : null } |
  { 'buying' : null } |
  { 'approving' : null } |
  { 'waiting_for_delivery' : null };
export type State__1 = { 'spawn_uncertain' : null } |
  { 'held' : string } |
  { 'mining' : null } |
  { 'approval_uncertain' : null } |
  { 'verifying' : null } |
  { 'combined_with' : bigint } |
  { 'spawning' : null } |
  { 'queued' : null } |
  { 'waiting_native_token' : null } |
  { 'ready' : null } |
  { 'approving' : null } |
  { 'below_minimum' : null };
export type Status = { 'pending' : null } |
  { 'paid' : Receipt } |
  { 'uncertain' : string } |
  { 'quoted' : null } |
  { 'failed' : string };
export interface Touch {
  'session_id' : string,
  'visit' : boolean,
  'visitor_id' : string,
  'sequence' : bigint,
}
export interface TradeOk {
  'fill' : Fill,
  'payout' : Payout,
  'refund' : [] | [Payout],
}
export interface Upload { 'data' : Uint8Array, 'content_type' : string }
export interface View {
  'id' : bigint,
  'upvoted' : boolean,
  'upvotes' : bigint,
  'title' : string,
  'description' : string,
  'created_at' : bigint,
  'author' : Principal,
}
export interface View__1 {
  'refreshing' : boolean,
  'website_cycles' : CycleSummary,
  'next_refresh_at' : bigint,
  'mining' : MiningSummary,
  'mining_cycles' : [] | [bigint],
  'max_sampled_accounts' : bigint,
  'target_accounts' : bigint,
  'ledger' : [] | [Principal],
  'sampled_accounts' : bigint,
  'mining_note' : string,
  'refresh_interval_seconds' : bigint,
  'balances' : [] | [BalanceSnapshot],
}
export interface View__2 {
  'next_allowed_at' : bigint,
  'pending' : boolean,
  'test_mode' : boolean,
  'day_start' : bigint,
  'used' : boolean,
  'available' : boolean,
}
export interface Withdrawal {
  'id' : bigint,
  'to' : Account,
  'attempted_at' : bigint,
  'status' : { 'pending' : null } |
    { 'paid' : bigint } |
    { 'uncertain' : string } |
    { 'failed' : string },
  'created_at' : bigint,
  'ledger' : Principal,
  'amount' : bigint,
}
export interface _SERVICE {
  'allocation_policy' : ActorMethod<[], AllocationPolicy>,
  'analytics_account_seen' : ActorMethod<[Provider], Result_2>,
  'analytics_snapshot' : ActorMethod<
    [],
    {
      'online_window_seconds' : bigint,
      'session_capacity_reached' : boolean,
      'daily_active_users' : bigint,
      'account_capacity_reached' : boolean,
      'active_window_seconds' : bigint,
      'test_mode' : boolean,
      'account_capacity' : bigint,
      'accounts_created' : bigint,
      'rate_limited' : boolean,
      'screened_tokens' : bigint,
      'visitor_capacity' : bigint,
      'since' : bigint,
      'visit_window_seconds' : bigint,
      'principal_accounts' : boolean,
      'session_capacity' : bigint,
      'unique_users' : bigint,
      'page_views' : bigint,
      'visitor_capacity_reached' : boolean,
      'users_online' : bigint,
      'observed_at' : bigint,
      'visits' : bigint,
      'client_reported' : boolean,
    }
  >,
  'analytics_touch' : ActorMethod<[Touch], Result_2>,
  'billing_config' : ActorMethod<[], Config__1>,
  'billing_mining_policy' : ActorMethod<[], Policy>,
  'cancel_reaction_quote' : ActorMethod<[bigint], Result_2>,
  'community' : ActorMethod<
    [Principal],
    {
      'pending' : boolean,
      'next_usd_cents' : bigint,
      'profile' : [] | [Profile],
    }
  >,
  'community_updates' : ActorMethod<
    [bigint, bigint],
    { 'total' : bigint, 'items' : Array<Profile> }
  >,
  'community_updates_v2' : ActorMethod<
    [bigint, bigint],
    { 'total' : bigint, 'items' : Array<ProfileV2> }
  >,
  'community_updates_v3' : ActorMethod<
    [bigint, bigint],
    { 'total' : bigint, 'items' : Array<ProfileV3> }
  >,
  'community_v2' : ActorMethod<
    [Principal],
    {
      'pending' : boolean,
      'next_usd_cents' : bigint,
      'profile' : [] | [ProfileV2],
    }
  >,
  'community_v3' : ActorMethod<
    [Principal],
    {
      'pending' : boolean,
      'next_usd_cents' : bigint,
      'profile' : [] | [ProfileV3],
    }
  >,
  'configure_billing' : ActorMethod<[Config__1], Result_2>,
  'configure_platform_metrics' : ActorMethod<[Config], Result_2>,
  'configure_reactions' : ActorMethod<[ReactionConfigInput], Result_2>,
  'configure_screener_market' : ActorMethod<[Principal], Result_2>,
  'create_reaction_quote' : ActorMethod<[Principal, ReactionKind], Result_3>,
  'favourites' : ActorMethod<[], Array<Principal>>,
  'feature_requests' : ActorMethod<[Sort, bigint, bigint], Page>,
  'has_paid_profile' : ActorMethod<[Principal], boolean>,
  'health' : ActorMethod<[], string>,
  'http_request' : ActorMethod<[Request], Response>,
  'mining_jobs' : ActorMethod<
    [bigint, bigint],
    { 'total' : bigint, 'items' : Array<Job__1> }
  >,
  'mining_status' : ActorMethod<[Principal], MarketStatus__1>,
  'my_pending_updates' : ActorMethod<[], Array<Quote>>,
  'my_pending_updates_v2' : ActorMethod<[], Array<QuoteV2>>,
  'my_pending_updates_v3' : ActorMethod<[], Array<QuoteV3>>,
  'my_quote_banner' : ActorMethod<[bigint], [] | [Image]>,
  'my_quote_mining' : ActorMethod<[bigint], [] | [QuotePolicy__1]>,
  'my_quote_screener' : ActorMethod<[bigint], [] | [QuotePolicy]>,
  'my_reaction_daily' : ActorMethod<[Principal], View__2>,
  'my_reaction_quote' : ActorMethod<[], [] | [ReactionQuote]>,
  'my_update' : ActorMethod<[bigint], [] | [Quote]>,
  'my_update_v2' : ActorMethod<[bigint], [] | [QuoteV2]>,
  'my_update_v3' : ActorMethod<[bigint], [] | [QuoteV3]>,
  'pay_reaction' : ActorMethod<[bigint], Result_3>,
  'platform_metrics' : ActorMethod<[], View__1>,
  'prepare_update' : ActorMethod<[Principal, Fields], Result_7>,
  'prepare_update_v2' : ActorMethod<[Principal, FieldsV2], Result_6>,
  'prepare_update_v3' : ActorMethod<[Principal, FieldsV3], Result_5>,
  'prepare_update_with_banner' : ActorMethod<
    [Principal, FieldsV3, [] | [Upload]],
    Result_5
  >,
  'process_mining' : ActorMethod<[], Result_2>,
  'process_screener' : ActorMethod<[], Result_2>,
  'profile_status' : ActorMethod<[Principal], ProfileStatus>,
  'profile_statuses' : ActorMethod<[Array<Principal>], Array<ProfileStatus>>,
  'publish_update' : ActorMethod<[bigint], Result_4>,
  'reaction_config' : ActorMethod<[], ReactionConfig>,
  'reaction_quote' : ActorMethod<[bigint], [] | [ReactionQuote]>,
  'reaction_totals' : ActorMethod<[Principal], ReactionTotals>,
  'reaction_totals_batch' : ActorMethod<
    [Array<Principal>],
    Array<ReactionTotals>
  >,
  'reconcile_mining' : ActorMethod<[bigint], Result_2>,
  'reconcile_reaction' : ActorMethod<[bigint, bigint], Result_3>,
  'reconcile_screener' : ActorMethod<[bigint], Result_2>,
  'reconcile_update' : ActorMethod<[bigint, bigint], Result_4>,
  'record_platform_cycles' : ActorMethod<[Array<CycleReport>], Result_2>,
  'recover_reaction' : ActorMethod<[bigint], Result_3>,
  'screener_jobs' : ActorMethod<
    [bigint, bigint],
    { 'total' : bigint, 'items' : Array<Job> }
  >,
  'screener_purchase' : ActorMethod<[bigint], [] | [PurchaseIntent]>,
  'screener_purchase_config' : ActorMethod<[], ConfigView>,
  'screener_reserve_status' : ActorMethod<[Principal], MarketStatus>,
  'set_favourite' : ActorMethod<[Principal, boolean], Result_2>,
  'set_feature_upvote' : ActorMethod<[bigint, boolean], Result_1>,
  'set_screener_purchases_enabled' : ActorMethod<[boolean], Result_2>,
  'submit_feature_request' : ActorMethod<[string, string], Result_1>,
  'wallet_account' : ActorMethod<[Principal], Uint8Array>,
  'withdraw_fees' : ActorMethod<[Account, bigint, bigint], Result>,
  'withdrawal_history' : ActorMethod<
    [],
    Array<[Principal, bigint, bigint, { 'ok' : bigint } | { 'err' : string }]>
  >,
  'withdrawal_status' : ActorMethod<[bigint], [] | [Withdrawal]>,
}
export const AllocationPolicy = IDL.Record({
  'all_in' : IDL.Bool,
  'mining_share_bps' : IDL.Nat,
  'purchases_enabled' : IDL.Bool,
  'version' : IDL.Nat,
  'native_token' : IDL.Opt(IDL.Principal),
  'screener_share_bps' : IDL.Nat,
  'pool_enabled' : IDL.Bool,
  'rounding_remainder' : IDL.Text,
});
export const Provider = IDL.Variant({
  'plug' : IDL.Null,
  'internet_identity' : IDL.Null,
});
export const Result_2 = IDL.Variant({ 'ok' : IDL.Null, 'err' : IDL.Text });
export const Touch = IDL.Record({
  'session_id' : IDL.Text,
  'visit' : IDL.Bool,
  'visitor_id' : IDL.Text,
  'sequence' : IDL.Nat64,
});
export const Config__1 = IDL.Record({
  'test_mode' : IDL.Bool,
  'enabled' : IDL.Bool,
  'ledger' : IDL.Principal,
  'factory' : IDL.Principal,
});
export const Policy = IDL.Record({
  'all_in' : IDL.Bool,
  'enabled' : IDL.Bool,
  'native_token' : IDL.Opt(IDL.Principal),
  'pool_enabled' : IDL.Bool,
  'share_bps' : IDL.Nat,
  'power' : IDL.Nat8,
});
export const Receipt = IDL.Record({
  'publisher' : IDL.Principal,
  'amount_e8s' : IDL.Nat,
  'usd_cents' : IDL.Nat,
  'ledger' : IDL.Principal,
  'paid_at' : IDL.Nat64,
  'block' : IDL.Nat,
  'revision' : IDL.Nat,
});
export const Fields = IDL.Record({
  'x' : IDL.Text,
  'description' : IDL.Text,
  'website' : IDL.Text,
  'discord' : IDL.Text,
  'telegram' : IDL.Text,
});
export const Profile = IDL.Record({
  'receipt' : Receipt,
  'fields' : Fields,
  'market' : IDL.Principal,
});
export const FieldsV2 = IDL.Record({
  'x' : IDL.Text,
  'banner' : IDL.Text,
  'description' : IDL.Text,
  'website' : IDL.Text,
  'discord' : IDL.Text,
  'telegram' : IDL.Text,
});
export const ProfileV2 = IDL.Record({
  'receipt' : Receipt,
  'fields' : FieldsV2,
  'market' : IDL.Principal,
});
export const Milestone = IDL.Record({
  'status' : IDL.Variant({
    'in_progress' : IDL.Null,
    'completed' : IDL.Null,
    'planned' : IDL.Null,
  }),
  'title' : IDL.Text,
  'description' : IDL.Text,
  'target_date' : IDL.Text,
});
export const FieldsV3 = IDL.Record({
  'x' : IDL.Text,
  'roadmap' : IDL.Vec(Milestone),
  'about' : IDL.Text,
  'banner' : IDL.Text,
  'description' : IDL.Text,
  'website' : IDL.Text,
  'discord' : IDL.Text,
  'telegram' : IDL.Text,
});
export const ProfileV3 = IDL.Record({
  'receipt' : Receipt,
  'test_mode' : IDL.Opt(IDL.Bool),
  'fields' : FieldsV3,
  'market' : IDL.Principal,
});
export const Config = IDL.Record({
  'ledger' : IDL.Principal,
  'canisters' : IDL.Vec(IDL.Principal),
});
export const ReactionConfigInput = IDL.Record({
  'test_mode' : IDL.Bool,
  'enabled' : IDL.Bool,
  'ledger' : IDL.Principal,
  'factory' : IDL.Principal,
});
export const ReactionKind = IDL.Variant({
  'fire' : IDL.Null,
  'flag' : IDL.Null,
  'poop' : IDL.Null,
  'rocket' : IDL.Null,
});
export const ReactionReceipt = IDL.Record({
  'test_mode' : IDL.Bool,
  'kind' : ReactionKind,
  'amount_e8s' : IDL.Nat,
  'ledger' : IDL.Principal,
  'paid_at' : IDL.Nat64,
  'block' : IDL.Nat,
  'market' : IDL.Principal,
});
export const ReactionStatus = IDL.Variant({
  'pending' : IDL.Null,
  'paid' : ReactionReceipt,
  'uncertain' : IDL.Text,
  'quoted' : IDL.Null,
  'failed' : IDL.Text,
});
export const Account = IDL.Record({
  'owner' : IDL.Principal,
  'subaccount' : IDL.Opt(IDL.Vec(IDL.Nat8)),
});
export const ReactionQuote = IDL.Record({
  'id' : IDL.Nat64,
  'attempted_at' : IDL.Opt(IDL.Nat64),
  'status' : ReactionStatus,
  'total_debit_e8s' : IDL.Nat,
  'test_mode' : IDL.Bool,
  'owner' : IDL.Principal,
  'kind' : ReactionKind,
  'created_at' : IDL.Nat64,
  'transfer_at' : IDL.Opt(IDL.Nat64),
  'allowance_e8s' : IDL.Nat,
  'amount_e8s' : IDL.Nat,
  'ledger_fee_e8s' : IDL.Nat,
  'config_version' : IDL.Nat,
  'ledger' : IDL.Principal,
  'scan_next' : IDL.Nat,
  'market' : IDL.Principal,
  'expires_at' : IDL.Nat64,
  'spender' : Account,
  'treasury' : Account,
  'scan_start' : IDL.Nat,
});
export const Result_3 = IDL.Variant({ 'ok' : ReactionQuote, 'err' : IDL.Text });
export const Sort = IDL.Variant({ 'top' : IDL.Null, 'newest' : IDL.Null });
export const View = IDL.Record({
  'id' : IDL.Nat64,
  'upvoted' : IDL.Bool,
  'upvotes' : IDL.Nat,
  'title' : IDL.Text,
  'description' : IDL.Text,
  'created_at' : IDL.Nat64,
  'author' : IDL.Principal,
});
export const Page = IDL.Record({ 'total' : IDL.Nat, 'items' : IDL.Vec(View) });
export const Request = IDL.Record({
  'url' : IDL.Text,
  'method' : IDL.Text,
  'body' : IDL.Vec(IDL.Nat8),
  'headers' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
  'certificate_version' : IDL.Opt(IDL.Nat16),
});
export const Response = IDL.Record({
  'body' : IDL.Vec(IDL.Nat8),
  'headers' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
  'upgrade' : IDL.Opt(IDL.Bool),
  'streaming_strategy' : IDL.Opt(
    IDL.Variant({
      'Callback' : IDL.Record({
        'token' : IDL.Vec(IDL.Nat8),
        'callback' : IDL.Func(
            [IDL.Vec(IDL.Nat8)],
            [
              IDL.Record({
                'token' : IDL.Opt(IDL.Vec(IDL.Nat8)),
                'body' : IDL.Vec(IDL.Nat8),
              }),
            ],
            ['query'],
          ),
      }),
    })
  ),
  'status_code' : IDL.Nat16,
});
export const State__1 = IDL.Variant({
  'spawn_uncertain' : IDL.Null,
  'held' : IDL.Text,
  'mining' : IDL.Null,
  'approval_uncertain' : IDL.Null,
  'verifying' : IDL.Null,
  'combined_with' : IDL.Nat64,
  'spawning' : IDL.Null,
  'queued' : IDL.Null,
  'waiting_native_token' : IDL.Null,
  'ready' : IDL.Null,
  'approving' : IDL.Null,
  'below_minimum' : IDL.Null,
});
export const Job__1 = IDL.Record({
  'rig' : IDL.Opt(IDL.Principal),
  'last_error' : IDL.Opt(IDL.Text),
  'status' : State__1,
  'allocation_e8s' : IDL.Nat,
  'approval_at' : IDL.Opt(IDL.Nat64),
  'updated_at' : IDL.Nat64,
  'approval_expires_at' : IDL.Opt(IDL.Nat64),
  'test_mode' : IDL.Bool,
  'available_tokens' : IDL.Opt(IDL.Nat),
  'minimum_e8s' : IDL.Opt(IDL.Nat64),
  'approval_fee_spent' : IDL.Bool,
  'spawn_at' : IDL.Opt(IDL.Nat64),
  'budget_e8s' : IDL.Nat,
  'ledger_fee_e8s' : IDL.Nat,
  'ledger' : IDL.Principal,
  'source_pool' : IDL.Opt(IDL.Principal),
  'fuel_e8s' : IDL.Nat,
  'factory' : IDL.Principal,
  'rewards' : IDL.Opt(IDL.Nat),
  'quote_id' : IDL.Nat64,
  'paid_at' : IDL.Nat64,
  'graduated' : IDL.Bool,
  'market' : IDL.Principal,
  'power' : IDL.Nat8,
  'receipt_block' : IDL.Nat,
  'revision' : IDL.Nat,
  'locked_rewards' : IDL.Opt(IDL.Nat),
  'rigs_before' : IDL.Vec(IDL.Principal),
  'token_ledger' : IDL.Opt(IDL.Principal),
  'approval_block' : IDL.Opt(IDL.Nat),
});
export const MarketStatus__1 = IDL.Record({
  'allocated_e8s' : IDL.Nat,
  'jobs' : IDL.Vec(Job__1),
  'rigs' : IDL.Vec(IDL.Principal),
  'native_token' : IDL.Opt(IDL.Principal),
  'reserved_e8s' : IDL.Nat,
  'pool_enabled' : IDL.Bool,
  'market' : IDL.Principal,
});
export const Status = IDL.Variant({
  'pending' : IDL.Null,
  'paid' : Receipt,
  'uncertain' : IDL.Text,
  'quoted' : IDL.Null,
  'failed' : IDL.Text,
});
export const Quote = IDL.Record({
  'id' : IDL.Nat64,
  'attempted_at' : IDL.Opt(IDL.Nat64),
  'status' : Status,
  'test_mode' : IDL.Bool,
  'owner' : IDL.Principal,
  'rate_at' : IDL.Nat64,
  'created_at' : IDL.Nat64,
  'base_revision' : IDL.Nat,
  'amount_e8s' : IDL.Nat,
  'fields' : Fields,
  'icp_usd_e8s' : IDL.Nat,
  'ledger_fee_e8s' : IDL.Nat,
  'config_version' : IDL.Nat,
  'usd_cents' : IDL.Nat,
  'ledger' : IDL.Principal,
  'market' : IDL.Principal,
  'expires_at' : IDL.Nat64,
});
export const QuoteV2 = IDL.Record({
  'id' : IDL.Nat64,
  'attempted_at' : IDL.Opt(IDL.Nat64),
  'status' : Status,
  'test_mode' : IDL.Bool,
  'owner' : IDL.Principal,
  'rate_at' : IDL.Nat64,
  'created_at' : IDL.Nat64,
  'base_revision' : IDL.Nat,
  'amount_e8s' : IDL.Nat,
  'fields' : FieldsV2,
  'icp_usd_e8s' : IDL.Nat,
  'ledger_fee_e8s' : IDL.Nat,
  'config_version' : IDL.Nat,
  'usd_cents' : IDL.Nat,
  'ledger' : IDL.Principal,
  'market' : IDL.Principal,
  'expires_at' : IDL.Nat64,
});
export const QuoteV3 = IDL.Record({
  'id' : IDL.Nat64,
  'attempted_at' : IDL.Opt(IDL.Nat64),
  'status' : Status,
  'test_mode' : IDL.Bool,
  'owner' : IDL.Principal,
  'rate_at' : IDL.Nat64,
  'created_at' : IDL.Nat64,
  'base_revision' : IDL.Nat,
  'amount_e8s' : IDL.Nat,
  'fields' : FieldsV3,
  'icp_usd_e8s' : IDL.Nat,
  'ledger_fee_e8s' : IDL.Nat,
  'config_version' : IDL.Nat,
  'usd_cents' : IDL.Nat,
  'ledger' : IDL.Principal,
  'market' : IDL.Principal,
  'expires_at' : IDL.Nat64,
});
export const Image = IDL.Record({
  'height' : IDL.Nat,
  'data' : IDL.Vec(IDL.Nat8),
  'content_type' : IDL.Text,
  'width' : IDL.Nat,
});
export const QuotePolicy__1 = IDL.Record({
  'test_mode' : IDL.Bool,
  'all_in' : IDL.Bool,
  'budget_e8s' : IDL.Nat,
  'ledger' : IDL.Principal,
  'factory' : IDL.Principal,
  'quote_id' : IDL.Nat64,
  'power' : IDL.Nat8,
});
export const QuotePolicy = IDL.Record({
  'test_mode' : IDL.Bool,
  'all_in' : IDL.Bool,
  'budget_e8s' : IDL.Nat,
  'ledger' : IDL.Principal,
  'factory' : IDL.Principal,
  'quote_id' : IDL.Nat64,
});
export const View__2 = IDL.Record({
  'next_allowed_at' : IDL.Nat64,
  'pending' : IDL.Bool,
  'test_mode' : IDL.Bool,
  'day_start' : IDL.Nat64,
  'used' : IDL.Bool,
  'available' : IDL.Bool,
});
export const CycleSummary = IDL.Record({
  'newest_sample_at' : IDL.Opt(IDL.Nat64),
  'source' : IDL.Text,
  'oldest_sample_at' : IDL.Opt(IDL.Nat64),
  'complete' : IDL.Bool,
  'cycles' : IDL.Opt(IDL.Nat),
  'stale' : IDL.Bool,
  'expected_canisters' : IDL.Nat,
  'covered_canisters' : IDL.Nat,
});
export const MiningSummary = IDL.Record({
  'covered_rigs' : IDL.Nat,
  'refreshing' : IDL.Bool,
  'updated_at' : IDL.Opt(IDL.Nat64),
  'source' : IDL.Text,
  'rigs' : IDL.Nat,
  'error' : IDL.Opt(IDL.Text),
  'complete' : IDL.Bool,
  'cycles' : IDL.Opt(IDL.Nat),
  'stale' : IDL.Bool,
  'limit_reached' : IDL.Bool,
});
export const BalanceSnapshot = IDL.Record({
  'updated_at' : IDL.Nat64,
  'canister_e8s' : IDL.Nat,
  'failed_accounts' : IDL.Nat,
  'canister_covered' : IDL.Nat,
  'wallet_covered' : IDL.Nat,
  'wallet_e8s' : IDL.Nat,
  'canister_accounts' : IDL.Nat,
  'combined_e8s' : IDL.Nat,
  'account_limit_reached' : IDL.Bool,
  'complete' : IDL.Bool,
  'started_at' : IDL.Nat64,
  'wallet_accounts' : IDL.Nat,
});
export const View__1 = IDL.Record({
  'refreshing' : IDL.Bool,
  'website_cycles' : CycleSummary,
  'next_refresh_at' : IDL.Nat64,
  'mining' : MiningSummary,
  'mining_cycles' : IDL.Opt(IDL.Nat),
  'max_sampled_accounts' : IDL.Nat,
  'target_accounts' : IDL.Nat,
  'ledger' : IDL.Opt(IDL.Principal),
  'sampled_accounts' : IDL.Nat,
  'mining_note' : IDL.Text,
  'refresh_interval_seconds' : IDL.Nat,
  'balances' : IDL.Opt(BalanceSnapshot),
});
export const Result_7 = IDL.Variant({ 'ok' : Quote, 'err' : IDL.Text });
export const Result_6 = IDL.Variant({ 'ok' : QuoteV2, 'err' : IDL.Text });
export const Result_5 = IDL.Variant({ 'ok' : QuoteV3, 'err' : IDL.Text });
export const Upload = IDL.Record({
  'data' : IDL.Vec(IDL.Nat8),
  'content_type' : IDL.Text,
});
export const ProfileStatus = IDL.Record({
  'updated_at' : IDL.Opt(IDL.Nat64),
  'has_profile' : IDL.Bool,
  'receipt' : IDL.Opt(Receipt),
  'pending' : IDL.Bool,
  'test_mode' : IDL.Opt(IDL.Bool),
  'publisher' : IDL.Opt(IDL.Principal),
  'paid' : IDL.Bool,
  'next_usd_cents' : IDL.Nat,
  'market' : IDL.Principal,
  'revision' : IDL.Nat,
});
export const Result_4 = IDL.Variant({ 'ok' : Receipt, 'err' : IDL.Text });
export const ReactionConfig = IDL.Record({
  'test_mode' : IDL.Bool,
  'generation' : IDL.Nat,
  'enabled' : IDL.Bool,
  'ledger' : IDL.Principal,
  'factory' : IDL.Principal,
  'quote_ttl_seconds' : IDL.Nat,
  'price_e8s' : IDL.Nat,
  'fee_policy' : IDL.Variant({ 'plus_network_fees' : IDL.Null }),
  'treasury' : Account,
});
export const ReactionTotals = IDL.Record({
  'updated_at' : IDL.Opt(IDL.Nat64),
  'total' : IDL.Nat,
  'test_mode' : IDL.Bool,
  'fire' : IDL.Nat,
  'flag' : IDL.Nat,
  'poop' : IDL.Nat,
  'market' : IDL.Principal,
  'rocket' : IDL.Nat,
});
export const Consumed = IDL.Record({
  'memory' : IDL.Nat,
  'canister_creation' : IDL.Nat,
  'burned_cycles' : IDL.Nat,
  'http_outcalls' : IDL.Nat,
  'instructions' : IDL.Nat,
  'uninstall' : IDL.Nat,
  'ingress_induction' : IDL.Nat,
  'request_and_response_transmission' : IDL.Nat,
  'compute_allocation' : IDL.Nat,
});
export const CycleReport = IDL.Record({
  'sampled_at' : IDL.Nat64,
  'canister' : IDL.Principal,
  'consumed' : Consumed,
});
export const State = IDL.Variant({
  'waiting_for_screener' : IDL.Null,
  'held' : IDL.Text,
  'approval_uncertain' : IDL.Null,
  'holding' : IDL.Null,
  'queued' : IDL.Null,
  'purchase_uncertain' : IDL.Null,
  'buying' : IDL.Null,
  'approving' : IDL.Null,
  'waiting_for_delivery' : IDL.Null,
});
export const Job = IDL.Record({
  'purchase_block' : IDL.Opt(IDL.Nat),
  'last_error' : IDL.Opt(IDL.Text),
  'status' : State,
  'allocation_e8s' : IDL.Nat,
  'updated_at' : IDL.Nat64,
  'test_mode' : IDL.Bool,
  'spent_e8s' : IDL.Nat,
  'purchased_tokens' : IDL.Opt(IDL.Nat),
  'budget_e8s' : IDL.Nat,
  'native_token' : IDL.Opt(IDL.Principal),
  'ledger' : IDL.Principal,
  'factory' : IDL.Principal,
  'quote_id' : IDL.Nat64,
  'paid_at' : IDL.Nat64,
  'market' : IDL.Principal,
  'receipt_block' : IDL.Nat,
  'revision' : IDL.Nat,
});
export const Payout = IDL.Variant({
  'Queued' : IDL.Record({ 'id' : IDL.Nat64 }),
  'Sent' : IDL.Record({ 'block' : IDL.Nat }),
});
export const Fill = IDL.Record({
  'out' : IDL.Nat,
  'base_net' : IDL.Nat,
  'completes' : IDL.Bool,
  'fee_platform' : IDL.Nat,
  'fee_creator' : IDL.Nat,
  'refund' : IDL.Nat,
});
export const TradeOk = IDL.Record({
  'fill' : Fill,
  'payout' : Payout,
  'refund' : IDL.Opt(Payout),
});
export const PurchaseIntent = IDL.Record({
  'native_start' : IDL.Nat,
  'last_error' : IDL.Opt(IDL.Text),
  'approval_at' : IDL.Opt(IDL.Nat64),
  'native_market' : IDL.Principal,
  'approval_expires_at' : IDL.Opt(IDL.Nat64),
  'default_debit_e8s' : IDL.Nat,
  'quoted_out' : IDL.Nat,
  'payment_scan_next' : IDL.Nat64,
  'refunded' : IDL.Bool,
  'recipient' : Account,
  'fee_e8s' : IDL.Nat,
  'payment_start' : IDL.Nat64,
  'observed_trade_id' : IDL.Opt(IDL.Nat64),
  'refund_e8s' : IDL.Nat,
  'approval_fee_spent' : IDL.Bool,
  'amount_e8s' : IDL.Nat,
  'payment_block' : IDL.Opt(IDL.Nat),
  'refund_payout' : IDL.Opt(Payout),
  'observed_allowance' : IDL.Opt(IDL.Nat),
  'scan_next' : IDL.Nat,
  'payout_block' : IDL.Opt(IDL.Nat),
  'quote_id' : IDL.Nat64,
  'trades_before' : IDL.Opt(IDL.Nat64),
  'buy_at' : IDL.Opt(IDL.Nat64),
  'buy_response' : IDL.Opt(TradeOk),
  'icp_balance' : IDL.Opt(IDL.Nat),
  'min_tokens_out' : IDL.Nat,
  'approval_block' : IDL.Opt(IDL.Nat),
  'native_balance' : IDL.Opt(IDL.Nat),
  'native_ledger' : IDL.Principal,
});
export const ConfigView = IDL.Record({
  'test_mode' : IDL.Opt(IDL.Bool),
  'slippage_bps' : IDL.Nat,
  'enabled' : IDL.Bool,
  'configured' : IDL.Bool,
  'ledger' : IDL.Opt(IDL.Principal),
  'factory' : IDL.Opt(IDL.Principal),
  'market' : IDL.Opt(IDL.Principal),
  'payment_ledger' : IDL.Opt(IDL.Principal),
});
export const MarketStatus = IDL.Record({
  'allocated_e8s' : IDL.Nat,
  'jobs' : IDL.Vec(Job),
  'purchases_enabled' : IDL.Bool,
  'native_token' : IDL.Opt(IDL.Principal),
  'reserved_e8s' : IDL.Nat,
  'acquired_tokens' : IDL.Opt(IDL.Nat),
  'pool_enabled' : IDL.Bool,
  'market' : IDL.Principal,
});
export const Result_1 = IDL.Variant({ 'ok' : View, 'err' : IDL.Text });
export const Result = IDL.Variant({ 'ok' : IDL.Nat, 'err' : IDL.Text });
export const Withdrawal = IDL.Record({
  'id' : IDL.Nat64,
  'to' : Account,
  'attempted_at' : IDL.Nat64,
  'status' : IDL.Variant({
    'pending' : IDL.Null,
    'paid' : IDL.Nat,
    'uncertain' : IDL.Text,
    'failed' : IDL.Text,
  }),
  'created_at' : IDL.Nat64,
  'ledger' : IDL.Principal,
  'amount' : IDL.Nat,
});

export const idlService: IDL.ServiceClass = IDL.Service({
  'allocation_policy' : IDL.Func([], [AllocationPolicy], ['query']),
  'analytics_account_seen' : IDL.Func([Provider], [Result_2], []),
  'analytics_snapshot' : IDL.Func(
      [],
      [
        IDL.Record({
          'online_window_seconds' : IDL.Nat,
          'session_capacity_reached' : IDL.Bool,
          'daily_active_users' : IDL.Nat,
          'account_capacity_reached' : IDL.Bool,
          'active_window_seconds' : IDL.Nat,
          'test_mode' : IDL.Bool,
          'account_capacity' : IDL.Nat,
          'accounts_created' : IDL.Nat,
          'rate_limited' : IDL.Bool,
          'screened_tokens' : IDL.Nat,
          'visitor_capacity' : IDL.Nat,
          'since' : IDL.Nat64,
          'visit_window_seconds' : IDL.Nat,
          'principal_accounts' : IDL.Bool,
          'session_capacity' : IDL.Nat,
          'unique_users' : IDL.Nat,
          'page_views' : IDL.Nat,
          'visitor_capacity_reached' : IDL.Bool,
          'users_online' : IDL.Nat,
          'observed_at' : IDL.Nat64,
          'visits' : IDL.Nat,
          'client_reported' : IDL.Bool,
        }),
      ],
      ['query'],
    ),
  'analytics_touch' : IDL.Func([Touch], [Result_2], []),
  'billing_config' : IDL.Func([], [Config__1], ['query']),
  'billing_mining_policy' : IDL.Func([], [Policy], ['query']),
  'cancel_reaction_quote' : IDL.Func([IDL.Nat64], [Result_2], []),
  'community' : IDL.Func(
      [IDL.Principal],
      [
        IDL.Record({
          'pending' : IDL.Bool,
          'next_usd_cents' : IDL.Nat,
          'profile' : IDL.Opt(Profile),
        }),
      ],
      ['query'],
    ),
  'community_updates' : IDL.Func(
      [IDL.Nat, IDL.Nat],
      [IDL.Record({ 'total' : IDL.Nat, 'items' : IDL.Vec(Profile) })],
      ['query'],
    ),
  'community_updates_v2' : IDL.Func(
      [IDL.Nat, IDL.Nat],
      [IDL.Record({ 'total' : IDL.Nat, 'items' : IDL.Vec(ProfileV2) })],
      ['query'],
    ),
  'community_updates_v3' : IDL.Func(
      [IDL.Nat, IDL.Nat],
      [IDL.Record({ 'total' : IDL.Nat, 'items' : IDL.Vec(ProfileV3) })],
      ['query'],
    ),
  'community_v2' : IDL.Func(
      [IDL.Principal],
      [
        IDL.Record({
          'pending' : IDL.Bool,
          'next_usd_cents' : IDL.Nat,
          'profile' : IDL.Opt(ProfileV2),
        }),
      ],
      ['query'],
    ),
  'community_v3' : IDL.Func(
      [IDL.Principal],
      [
        IDL.Record({
          'pending' : IDL.Bool,
          'next_usd_cents' : IDL.Nat,
          'profile' : IDL.Opt(ProfileV3),
        }),
      ],
      ['query'],
    ),
  'configure_billing' : IDL.Func([Config__1], [Result_2], []),
  'configure_platform_metrics' : IDL.Func([Config], [Result_2], []),
  'configure_reactions' : IDL.Func([ReactionConfigInput], [Result_2], []),
  'configure_screener_market' : IDL.Func([IDL.Principal], [Result_2], []),
  'create_reaction_quote' : IDL.Func(
      [IDL.Principal, ReactionKind],
      [Result_3],
      [],
    ),
  'favourites' : IDL.Func([], [IDL.Vec(IDL.Principal)], ['query']),
  'feature_requests' : IDL.Func([Sort, IDL.Nat, IDL.Nat], [Page], ['query']),
  'has_paid_profile' : IDL.Func([IDL.Principal], [IDL.Bool], ['query']),
  'health' : IDL.Func([], [IDL.Text], ['query']),
  'http_request' : IDL.Func([Request], [Response], ['query']),
  'mining_jobs' : IDL.Func(
      [IDL.Nat, IDL.Nat],
      [IDL.Record({ 'total' : IDL.Nat, 'items' : IDL.Vec(Job__1) })],
      ['query'],
    ),
  'mining_status' : IDL.Func([IDL.Principal], [MarketStatus__1], ['query']),
  'my_pending_updates' : IDL.Func([], [IDL.Vec(Quote)], ['query']),
  'my_pending_updates_v2' : IDL.Func([], [IDL.Vec(QuoteV2)], ['query']),
  'my_pending_updates_v3' : IDL.Func([], [IDL.Vec(QuoteV3)], ['query']),
  'my_quote_banner' : IDL.Func([IDL.Nat64], [IDL.Opt(Image)], ['query']),
  'my_quote_mining' : IDL.Func(
      [IDL.Nat64],
      [IDL.Opt(QuotePolicy__1)],
      ['query'],
    ),
  'my_quote_screener' : IDL.Func(
      [IDL.Nat64],
      [IDL.Opt(QuotePolicy)],
      ['query'],
    ),
  'my_reaction_daily' : IDL.Func([IDL.Principal], [View__2], ['query']),
  'my_reaction_quote' : IDL.Func([], [IDL.Opt(ReactionQuote)], ['query']),
  'my_update' : IDL.Func([IDL.Nat64], [IDL.Opt(Quote)], ['query']),
  'my_update_v2' : IDL.Func([IDL.Nat64], [IDL.Opt(QuoteV2)], ['query']),
  'my_update_v3' : IDL.Func([IDL.Nat64], [IDL.Opt(QuoteV3)], ['query']),
  'pay_reaction' : IDL.Func([IDL.Nat64], [Result_3], []),
  'platform_metrics' : IDL.Func([], [View__1], ['query']),
  'prepare_update' : IDL.Func([IDL.Principal, Fields], [Result_7], []),
  'prepare_update_v2' : IDL.Func([IDL.Principal, FieldsV2], [Result_6], []),
  'prepare_update_v3' : IDL.Func([IDL.Principal, FieldsV3], [Result_5], []),
  'prepare_update_with_banner' : IDL.Func(
      [IDL.Principal, FieldsV3, IDL.Opt(Upload)],
      [Result_5],
      [],
    ),
  'process_mining' : IDL.Func([], [Result_2], []),
  'process_screener' : IDL.Func([], [Result_2], []),
  'profile_status' : IDL.Func([IDL.Principal], [ProfileStatus], ['query']),
  'profile_statuses' : IDL.Func(
      [IDL.Vec(IDL.Principal)],
      [IDL.Vec(ProfileStatus)],
      ['query'],
    ),
  'publish_update' : IDL.Func([IDL.Nat64], [Result_4], []),
  'reaction_config' : IDL.Func([], [ReactionConfig], ['query']),
  'reaction_quote' : IDL.Func([IDL.Nat64], [IDL.Opt(ReactionQuote)], ['query']),
  'reaction_totals' : IDL.Func([IDL.Principal], [ReactionTotals], ['query']),
  'reaction_totals_batch' : IDL.Func(
      [IDL.Vec(IDL.Principal)],
      [IDL.Vec(ReactionTotals)],
      ['query'],
    ),
  'reconcile_mining' : IDL.Func([IDL.Nat64], [Result_2], []),
  'reconcile_reaction' : IDL.Func([IDL.Nat64, IDL.Nat], [Result_3], []),
  'reconcile_screener' : IDL.Func([IDL.Nat64], [Result_2], []),
  'reconcile_update' : IDL.Func([IDL.Nat64, IDL.Nat64], [Result_4], []),
  'record_platform_cycles' : IDL.Func([IDL.Vec(CycleReport)], [Result_2], []),
  'recover_reaction' : IDL.Func([IDL.Nat64], [Result_3], []),
  'screener_jobs' : IDL.Func(
      [IDL.Nat, IDL.Nat],
      [IDL.Record({ 'total' : IDL.Nat, 'items' : IDL.Vec(Job) })],
      ['query'],
    ),
  'screener_purchase' : IDL.Func(
      [IDL.Nat64],
      [IDL.Opt(PurchaseIntent)],
      ['query'],
    ),
  'screener_purchase_config' : IDL.Func([], [ConfigView], ['query']),
  'screener_reserve_status' : IDL.Func(
      [IDL.Principal],
      [MarketStatus],
      ['query'],
    ),
  'set_favourite' : IDL.Func([IDL.Principal, IDL.Bool], [Result_2], []),
  'set_feature_upvote' : IDL.Func([IDL.Nat64, IDL.Bool], [Result_1], []),
  'set_screener_purchases_enabled' : IDL.Func([IDL.Bool], [Result_2], []),
  'submit_feature_request' : IDL.Func([IDL.Text, IDL.Text], [Result_1], []),
  'wallet_account' : IDL.Func([IDL.Principal], [IDL.Vec(IDL.Nat8)], ['query']),
  'withdraw_fees' : IDL.Func([Account, IDL.Nat, IDL.Nat64], [Result], []),
  'withdrawal_history' : IDL.Func(
      [],
      [
        IDL.Vec(
          IDL.Tuple(
            IDL.Principal,
            IDL.Nat,
            IDL.Nat64,
            IDL.Variant({ 'ok' : IDL.Nat, 'err' : IDL.Text }),
          )
        ),
      ],
      ['query'],
    ),
  'withdrawal_status' : IDL.Func([IDL.Nat64], [IDL.Opt(Withdrawal)], ['query']),
});

export const idlInitArgs: IDL.Type[] = [];

export const idlFactory: IDL.InterfaceFactory = ({ IDL }) => {
  const AllocationPolicy = IDL.Record({
    'all_in' : IDL.Bool,
    'mining_share_bps' : IDL.Nat,
    'purchases_enabled' : IDL.Bool,
    'version' : IDL.Nat,
    'native_token' : IDL.Opt(IDL.Principal),
    'screener_share_bps' : IDL.Nat,
    'pool_enabled' : IDL.Bool,
    'rounding_remainder' : IDL.Text,
  });
  const Provider = IDL.Variant({
    'plug' : IDL.Null,
    'internet_identity' : IDL.Null,
  });
  const Result_2 = IDL.Variant({ 'ok' : IDL.Null, 'err' : IDL.Text });
  const Touch = IDL.Record({
    'session_id' : IDL.Text,
    'visit' : IDL.Bool,
    'visitor_id' : IDL.Text,
    'sequence' : IDL.Nat64,
  });
  const Config__1 = IDL.Record({
    'test_mode' : IDL.Bool,
    'enabled' : IDL.Bool,
    'ledger' : IDL.Principal,
    'factory' : IDL.Principal,
  });
  const Policy = IDL.Record({
    'all_in' : IDL.Bool,
    'enabled' : IDL.Bool,
    'native_token' : IDL.Opt(IDL.Principal),
    'pool_enabled' : IDL.Bool,
    'share_bps' : IDL.Nat,
    'power' : IDL.Nat8,
  });
  const Receipt = IDL.Record({
    'publisher' : IDL.Principal,
    'amount_e8s' : IDL.Nat,
    'usd_cents' : IDL.Nat,
    'ledger' : IDL.Principal,
    'paid_at' : IDL.Nat64,
    'block' : IDL.Nat,
    'revision' : IDL.Nat,
  });
  const Fields = IDL.Record({
    'x' : IDL.Text,
    'description' : IDL.Text,
    'website' : IDL.Text,
    'discord' : IDL.Text,
    'telegram' : IDL.Text,
  });
  const Profile = IDL.Record({
    'receipt' : Receipt,
    'fields' : Fields,
    'market' : IDL.Principal,
  });
  const FieldsV2 = IDL.Record({
    'x' : IDL.Text,
    'banner' : IDL.Text,
    'description' : IDL.Text,
    'website' : IDL.Text,
    'discord' : IDL.Text,
    'telegram' : IDL.Text,
  });
  const ProfileV2 = IDL.Record({
    'receipt' : Receipt,
    'fields' : FieldsV2,
    'market' : IDL.Principal,
  });
  const Milestone = IDL.Record({
    'status' : IDL.Variant({
      'in_progress' : IDL.Null,
      'completed' : IDL.Null,
      'planned' : IDL.Null,
    }),
    'title' : IDL.Text,
    'description' : IDL.Text,
    'target_date' : IDL.Text,
  });
  const FieldsV3 = IDL.Record({
    'x' : IDL.Text,
    'roadmap' : IDL.Vec(Milestone),
    'about' : IDL.Text,
    'banner' : IDL.Text,
    'description' : IDL.Text,
    'website' : IDL.Text,
    'discord' : IDL.Text,
    'telegram' : IDL.Text,
  });
  const ProfileV3 = IDL.Record({
    'receipt' : Receipt,
    'test_mode' : IDL.Opt(IDL.Bool),
    'fields' : FieldsV3,
    'market' : IDL.Principal,
  });
  const Config = IDL.Record({
    'ledger' : IDL.Principal,
    'canisters' : IDL.Vec(IDL.Principal),
  });
  const ReactionConfigInput = IDL.Record({
    'test_mode' : IDL.Bool,
    'enabled' : IDL.Bool,
    'ledger' : IDL.Principal,
    'factory' : IDL.Principal,
  });
  const ReactionKind = IDL.Variant({
    'fire' : IDL.Null,
    'flag' : IDL.Null,
    'poop' : IDL.Null,
    'rocket' : IDL.Null,
  });
  const ReactionReceipt = IDL.Record({
    'test_mode' : IDL.Bool,
    'kind' : ReactionKind,
    'amount_e8s' : IDL.Nat,
    'ledger' : IDL.Principal,
    'paid_at' : IDL.Nat64,
    'block' : IDL.Nat,
    'market' : IDL.Principal,
  });
  const ReactionStatus = IDL.Variant({
    'pending' : IDL.Null,
    'paid' : ReactionReceipt,
    'uncertain' : IDL.Text,
    'quoted' : IDL.Null,
    'failed' : IDL.Text,
  });
  const Account = IDL.Record({
    'owner' : IDL.Principal,
    'subaccount' : IDL.Opt(IDL.Vec(IDL.Nat8)),
  });
  const ReactionQuote = IDL.Record({
    'id' : IDL.Nat64,
    'attempted_at' : IDL.Opt(IDL.Nat64),
    'status' : ReactionStatus,
    'total_debit_e8s' : IDL.Nat,
    'test_mode' : IDL.Bool,
    'owner' : IDL.Principal,
    'kind' : ReactionKind,
    'created_at' : IDL.Nat64,
    'transfer_at' : IDL.Opt(IDL.Nat64),
    'allowance_e8s' : IDL.Nat,
    'amount_e8s' : IDL.Nat,
    'ledger_fee_e8s' : IDL.Nat,
    'config_version' : IDL.Nat,
    'ledger' : IDL.Principal,
    'scan_next' : IDL.Nat,
    'market' : IDL.Principal,
    'expires_at' : IDL.Nat64,
    'spender' : Account,
    'treasury' : Account,
    'scan_start' : IDL.Nat,
  });
  const Result_3 = IDL.Variant({ 'ok' : ReactionQuote, 'err' : IDL.Text });
  const Sort = IDL.Variant({ 'top' : IDL.Null, 'newest' : IDL.Null });
  const View = IDL.Record({
    'id' : IDL.Nat64,
    'upvoted' : IDL.Bool,
    'upvotes' : IDL.Nat,
    'title' : IDL.Text,
    'description' : IDL.Text,
    'created_at' : IDL.Nat64,
    'author' : IDL.Principal,
  });
  const Page = IDL.Record({ 'total' : IDL.Nat, 'items' : IDL.Vec(View) });
  const Request = IDL.Record({
    'url' : IDL.Text,
    'method' : IDL.Text,
    'body' : IDL.Vec(IDL.Nat8),
    'headers' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'certificate_version' : IDL.Opt(IDL.Nat16),
  });
  const Response = IDL.Record({
    'body' : IDL.Vec(IDL.Nat8),
    'headers' : IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    'upgrade' : IDL.Opt(IDL.Bool),
    'streaming_strategy' : IDL.Opt(
      IDL.Variant({
        'Callback' : IDL.Record({
          'token' : IDL.Vec(IDL.Nat8),
          'callback' : IDL.Func(
              [IDL.Vec(IDL.Nat8)],
              [
                IDL.Record({
                  'token' : IDL.Opt(IDL.Vec(IDL.Nat8)),
                  'body' : IDL.Vec(IDL.Nat8),
                }),
              ],
              ['query'],
            ),
        }),
      })
    ),
    'status_code' : IDL.Nat16,
  });
  const State__1 = IDL.Variant({
    'spawn_uncertain' : IDL.Null,
    'held' : IDL.Text,
    'mining' : IDL.Null,
    'approval_uncertain' : IDL.Null,
    'verifying' : IDL.Null,
    'combined_with' : IDL.Nat64,
    'spawning' : IDL.Null,
    'queued' : IDL.Null,
    'waiting_native_token' : IDL.Null,
    'ready' : IDL.Null,
    'approving' : IDL.Null,
    'below_minimum' : IDL.Null,
  });
  const Job__1 = IDL.Record({
    'rig' : IDL.Opt(IDL.Principal),
    'last_error' : IDL.Opt(IDL.Text),
    'status' : State__1,
    'allocation_e8s' : IDL.Nat,
    'approval_at' : IDL.Opt(IDL.Nat64),
    'updated_at' : IDL.Nat64,
    'approval_expires_at' : IDL.Opt(IDL.Nat64),
    'test_mode' : IDL.Bool,
    'available_tokens' : IDL.Opt(IDL.Nat),
    'minimum_e8s' : IDL.Opt(IDL.Nat64),
    'approval_fee_spent' : IDL.Bool,
    'spawn_at' : IDL.Opt(IDL.Nat64),
    'budget_e8s' : IDL.Nat,
    'ledger_fee_e8s' : IDL.Nat,
    'ledger' : IDL.Principal,
    'source_pool' : IDL.Opt(IDL.Principal),
    'fuel_e8s' : IDL.Nat,
    'factory' : IDL.Principal,
    'rewards' : IDL.Opt(IDL.Nat),
    'quote_id' : IDL.Nat64,
    'paid_at' : IDL.Nat64,
    'graduated' : IDL.Bool,
    'market' : IDL.Principal,
    'power' : IDL.Nat8,
    'receipt_block' : IDL.Nat,
    'revision' : IDL.Nat,
    'locked_rewards' : IDL.Opt(IDL.Nat),
    'rigs_before' : IDL.Vec(IDL.Principal),
    'token_ledger' : IDL.Opt(IDL.Principal),
    'approval_block' : IDL.Opt(IDL.Nat),
  });
  const MarketStatus__1 = IDL.Record({
    'allocated_e8s' : IDL.Nat,
    'jobs' : IDL.Vec(Job__1),
    'rigs' : IDL.Vec(IDL.Principal),
    'native_token' : IDL.Opt(IDL.Principal),
    'reserved_e8s' : IDL.Nat,
    'pool_enabled' : IDL.Bool,
    'market' : IDL.Principal,
  });
  const Status = IDL.Variant({
    'pending' : IDL.Null,
    'paid' : Receipt,
    'uncertain' : IDL.Text,
    'quoted' : IDL.Null,
    'failed' : IDL.Text,
  });
  const Quote = IDL.Record({
    'id' : IDL.Nat64,
    'attempted_at' : IDL.Opt(IDL.Nat64),
    'status' : Status,
    'test_mode' : IDL.Bool,
    'owner' : IDL.Principal,
    'rate_at' : IDL.Nat64,
    'created_at' : IDL.Nat64,
    'base_revision' : IDL.Nat,
    'amount_e8s' : IDL.Nat,
    'fields' : Fields,
    'icp_usd_e8s' : IDL.Nat,
    'ledger_fee_e8s' : IDL.Nat,
    'config_version' : IDL.Nat,
    'usd_cents' : IDL.Nat,
    'ledger' : IDL.Principal,
    'market' : IDL.Principal,
    'expires_at' : IDL.Nat64,
  });
  const QuoteV2 = IDL.Record({
    'id' : IDL.Nat64,
    'attempted_at' : IDL.Opt(IDL.Nat64),
    'status' : Status,
    'test_mode' : IDL.Bool,
    'owner' : IDL.Principal,
    'rate_at' : IDL.Nat64,
    'created_at' : IDL.Nat64,
    'base_revision' : IDL.Nat,
    'amount_e8s' : IDL.Nat,
    'fields' : FieldsV2,
    'icp_usd_e8s' : IDL.Nat,
    'ledger_fee_e8s' : IDL.Nat,
    'config_version' : IDL.Nat,
    'usd_cents' : IDL.Nat,
    'ledger' : IDL.Principal,
    'market' : IDL.Principal,
    'expires_at' : IDL.Nat64,
  });
  const QuoteV3 = IDL.Record({
    'id' : IDL.Nat64,
    'attempted_at' : IDL.Opt(IDL.Nat64),
    'status' : Status,
    'test_mode' : IDL.Bool,
    'owner' : IDL.Principal,
    'rate_at' : IDL.Nat64,
    'created_at' : IDL.Nat64,
    'base_revision' : IDL.Nat,
    'amount_e8s' : IDL.Nat,
    'fields' : FieldsV3,
    'icp_usd_e8s' : IDL.Nat,
    'ledger_fee_e8s' : IDL.Nat,
    'config_version' : IDL.Nat,
    'usd_cents' : IDL.Nat,
    'ledger' : IDL.Principal,
    'market' : IDL.Principal,
    'expires_at' : IDL.Nat64,
  });
  const Image = IDL.Record({
    'height' : IDL.Nat,
    'data' : IDL.Vec(IDL.Nat8),
    'content_type' : IDL.Text,
    'width' : IDL.Nat,
  });
  const QuotePolicy__1 = IDL.Record({
    'test_mode' : IDL.Bool,
    'all_in' : IDL.Bool,
    'budget_e8s' : IDL.Nat,
    'ledger' : IDL.Principal,
    'factory' : IDL.Principal,
    'quote_id' : IDL.Nat64,
    'power' : IDL.Nat8,
  });
  const QuotePolicy = IDL.Record({
    'test_mode' : IDL.Bool,
    'all_in' : IDL.Bool,
    'budget_e8s' : IDL.Nat,
    'ledger' : IDL.Principal,
    'factory' : IDL.Principal,
    'quote_id' : IDL.Nat64,
  });
  const View__2 = IDL.Record({
    'next_allowed_at' : IDL.Nat64,
    'pending' : IDL.Bool,
    'test_mode' : IDL.Bool,
    'day_start' : IDL.Nat64,
    'used' : IDL.Bool,
    'available' : IDL.Bool,
  });
  const CycleSummary = IDL.Record({
    'newest_sample_at' : IDL.Opt(IDL.Nat64),
    'source' : IDL.Text,
    'oldest_sample_at' : IDL.Opt(IDL.Nat64),
    'complete' : IDL.Bool,
    'cycles' : IDL.Opt(IDL.Nat),
    'stale' : IDL.Bool,
    'expected_canisters' : IDL.Nat,
    'covered_canisters' : IDL.Nat,
  });
  const MiningSummary = IDL.Record({
    'covered_rigs' : IDL.Nat,
    'refreshing' : IDL.Bool,
    'updated_at' : IDL.Opt(IDL.Nat64),
    'source' : IDL.Text,
    'rigs' : IDL.Nat,
    'error' : IDL.Opt(IDL.Text),
    'complete' : IDL.Bool,
    'cycles' : IDL.Opt(IDL.Nat),
    'stale' : IDL.Bool,
    'limit_reached' : IDL.Bool,
  });
  const BalanceSnapshot = IDL.Record({
    'updated_at' : IDL.Nat64,
    'canister_e8s' : IDL.Nat,
    'failed_accounts' : IDL.Nat,
    'canister_covered' : IDL.Nat,
    'wallet_covered' : IDL.Nat,
    'wallet_e8s' : IDL.Nat,
    'canister_accounts' : IDL.Nat,
    'combined_e8s' : IDL.Nat,
    'account_limit_reached' : IDL.Bool,
    'complete' : IDL.Bool,
    'started_at' : IDL.Nat64,
    'wallet_accounts' : IDL.Nat,
  });
  const View__1 = IDL.Record({
    'refreshing' : IDL.Bool,
    'website_cycles' : CycleSummary,
    'next_refresh_at' : IDL.Nat64,
    'mining' : MiningSummary,
    'mining_cycles' : IDL.Opt(IDL.Nat),
    'max_sampled_accounts' : IDL.Nat,
    'target_accounts' : IDL.Nat,
    'ledger' : IDL.Opt(IDL.Principal),
    'sampled_accounts' : IDL.Nat,
    'mining_note' : IDL.Text,
    'refresh_interval_seconds' : IDL.Nat,
    'balances' : IDL.Opt(BalanceSnapshot),
  });
  const Result_7 = IDL.Variant({ 'ok' : Quote, 'err' : IDL.Text });
  const Result_6 = IDL.Variant({ 'ok' : QuoteV2, 'err' : IDL.Text });
  const Result_5 = IDL.Variant({ 'ok' : QuoteV3, 'err' : IDL.Text });
  const Upload = IDL.Record({
    'data' : IDL.Vec(IDL.Nat8),
    'content_type' : IDL.Text,
  });
  const ProfileStatus = IDL.Record({
    'updated_at' : IDL.Opt(IDL.Nat64),
    'has_profile' : IDL.Bool,
    'receipt' : IDL.Opt(Receipt),
    'pending' : IDL.Bool,
    'test_mode' : IDL.Opt(IDL.Bool),
    'publisher' : IDL.Opt(IDL.Principal),
    'paid' : IDL.Bool,
    'next_usd_cents' : IDL.Nat,
    'market' : IDL.Principal,
    'revision' : IDL.Nat,
  });
  const Result_4 = IDL.Variant({ 'ok' : Receipt, 'err' : IDL.Text });
  const ReactionConfig = IDL.Record({
    'test_mode' : IDL.Bool,
    'generation' : IDL.Nat,
    'enabled' : IDL.Bool,
    'ledger' : IDL.Principal,
    'factory' : IDL.Principal,
    'quote_ttl_seconds' : IDL.Nat,
    'price_e8s' : IDL.Nat,
    'fee_policy' : IDL.Variant({ 'plus_network_fees' : IDL.Null }),
    'treasury' : Account,
  });
  const ReactionTotals = IDL.Record({
    'updated_at' : IDL.Opt(IDL.Nat64),
    'total' : IDL.Nat,
    'test_mode' : IDL.Bool,
    'fire' : IDL.Nat,
    'flag' : IDL.Nat,
    'poop' : IDL.Nat,
    'market' : IDL.Principal,
    'rocket' : IDL.Nat,
  });
  const Consumed = IDL.Record({
    'memory' : IDL.Nat,
    'canister_creation' : IDL.Nat,
    'burned_cycles' : IDL.Nat,
    'http_outcalls' : IDL.Nat,
    'instructions' : IDL.Nat,
    'uninstall' : IDL.Nat,
    'ingress_induction' : IDL.Nat,
    'request_and_response_transmission' : IDL.Nat,
    'compute_allocation' : IDL.Nat,
  });
  const CycleReport = IDL.Record({
    'sampled_at' : IDL.Nat64,
    'canister' : IDL.Principal,
    'consumed' : Consumed,
  });
  const State = IDL.Variant({
    'waiting_for_screener' : IDL.Null,
    'held' : IDL.Text,
    'approval_uncertain' : IDL.Null,
    'holding' : IDL.Null,
    'queued' : IDL.Null,
    'purchase_uncertain' : IDL.Null,
    'buying' : IDL.Null,
    'approving' : IDL.Null,
    'waiting_for_delivery' : IDL.Null,
  });
  const Job = IDL.Record({
    'purchase_block' : IDL.Opt(IDL.Nat),
    'last_error' : IDL.Opt(IDL.Text),
    'status' : State,
    'allocation_e8s' : IDL.Nat,
    'updated_at' : IDL.Nat64,
    'test_mode' : IDL.Bool,
    'spent_e8s' : IDL.Nat,
    'purchased_tokens' : IDL.Opt(IDL.Nat),
    'budget_e8s' : IDL.Nat,
    'native_token' : IDL.Opt(IDL.Principal),
    'ledger' : IDL.Principal,
    'factory' : IDL.Principal,
    'quote_id' : IDL.Nat64,
    'paid_at' : IDL.Nat64,
    'market' : IDL.Principal,
    'receipt_block' : IDL.Nat,
    'revision' : IDL.Nat,
  });
  const Payout = IDL.Variant({
    'Queued' : IDL.Record({ 'id' : IDL.Nat64 }),
    'Sent' : IDL.Record({ 'block' : IDL.Nat }),
  });
  const Fill = IDL.Record({
    'out' : IDL.Nat,
    'base_net' : IDL.Nat,
    'completes' : IDL.Bool,
    'fee_platform' : IDL.Nat,
    'fee_creator' : IDL.Nat,
    'refund' : IDL.Nat,
  });
  const TradeOk = IDL.Record({
    'fill' : Fill,
    'payout' : Payout,
    'refund' : IDL.Opt(Payout),
  });
  const PurchaseIntent = IDL.Record({
    'native_start' : IDL.Nat,
    'last_error' : IDL.Opt(IDL.Text),
    'approval_at' : IDL.Opt(IDL.Nat64),
    'native_market' : IDL.Principal,
    'approval_expires_at' : IDL.Opt(IDL.Nat64),
    'default_debit_e8s' : IDL.Nat,
    'quoted_out' : IDL.Nat,
    'payment_scan_next' : IDL.Nat64,
    'refunded' : IDL.Bool,
    'recipient' : Account,
    'fee_e8s' : IDL.Nat,
    'payment_start' : IDL.Nat64,
    'observed_trade_id' : IDL.Opt(IDL.Nat64),
    'refund_e8s' : IDL.Nat,
    'approval_fee_spent' : IDL.Bool,
    'amount_e8s' : IDL.Nat,
    'payment_block' : IDL.Opt(IDL.Nat),
    'refund_payout' : IDL.Opt(Payout),
    'observed_allowance' : IDL.Opt(IDL.Nat),
    'scan_next' : IDL.Nat,
    'payout_block' : IDL.Opt(IDL.Nat),
    'quote_id' : IDL.Nat64,
    'trades_before' : IDL.Opt(IDL.Nat64),
    'buy_at' : IDL.Opt(IDL.Nat64),
    'buy_response' : IDL.Opt(TradeOk),
    'icp_balance' : IDL.Opt(IDL.Nat),
    'min_tokens_out' : IDL.Nat,
    'approval_block' : IDL.Opt(IDL.Nat),
    'native_balance' : IDL.Opt(IDL.Nat),
    'native_ledger' : IDL.Principal,
  });
  const ConfigView = IDL.Record({
    'test_mode' : IDL.Opt(IDL.Bool),
    'slippage_bps' : IDL.Nat,
    'enabled' : IDL.Bool,
    'configured' : IDL.Bool,
    'ledger' : IDL.Opt(IDL.Principal),
    'factory' : IDL.Opt(IDL.Principal),
    'market' : IDL.Opt(IDL.Principal),
    'payment_ledger' : IDL.Opt(IDL.Principal),
  });
  const MarketStatus = IDL.Record({
    'allocated_e8s' : IDL.Nat,
    'jobs' : IDL.Vec(Job),
    'purchases_enabled' : IDL.Bool,
    'native_token' : IDL.Opt(IDL.Principal),
    'reserved_e8s' : IDL.Nat,
    'acquired_tokens' : IDL.Opt(IDL.Nat),
    'pool_enabled' : IDL.Bool,
    'market' : IDL.Principal,
  });
  const Result_1 = IDL.Variant({ 'ok' : View, 'err' : IDL.Text });
  const Result = IDL.Variant({ 'ok' : IDL.Nat, 'err' : IDL.Text });
  const Withdrawal = IDL.Record({
    'id' : IDL.Nat64,
    'to' : Account,
    'attempted_at' : IDL.Nat64,
    'status' : IDL.Variant({
      'pending' : IDL.Null,
      'paid' : IDL.Nat,
      'uncertain' : IDL.Text,
      'failed' : IDL.Text,
    }),
    'created_at' : IDL.Nat64,
    'ledger' : IDL.Principal,
    'amount' : IDL.Nat,
  });

  return IDL.Service({
    'allocation_policy' : IDL.Func([], [AllocationPolicy], ['query']),
    'analytics_account_seen' : IDL.Func([Provider], [Result_2], []),
    'analytics_snapshot' : IDL.Func(
        [],
        [
          IDL.Record({
            'online_window_seconds' : IDL.Nat,
            'session_capacity_reached' : IDL.Bool,
            'daily_active_users' : IDL.Nat,
            'account_capacity_reached' : IDL.Bool,
            'active_window_seconds' : IDL.Nat,
            'test_mode' : IDL.Bool,
            'account_capacity' : IDL.Nat,
            'accounts_created' : IDL.Nat,
            'rate_limited' : IDL.Bool,
            'screened_tokens' : IDL.Nat,
            'visitor_capacity' : IDL.Nat,
            'since' : IDL.Nat64,
            'visit_window_seconds' : IDL.Nat,
            'principal_accounts' : IDL.Bool,
            'session_capacity' : IDL.Nat,
            'unique_users' : IDL.Nat,
            'page_views' : IDL.Nat,
            'visitor_capacity_reached' : IDL.Bool,
            'users_online' : IDL.Nat,
            'observed_at' : IDL.Nat64,
            'visits' : IDL.Nat,
            'client_reported' : IDL.Bool,
          }),
        ],
        ['query'],
      ),
    'analytics_touch' : IDL.Func([Touch], [Result_2], []),
    'billing_config' : IDL.Func([], [Config__1], ['query']),
    'billing_mining_policy' : IDL.Func([], [Policy], ['query']),
    'cancel_reaction_quote' : IDL.Func([IDL.Nat64], [Result_2], []),
    'community' : IDL.Func(
        [IDL.Principal],
        [
          IDL.Record({
            'pending' : IDL.Bool,
            'next_usd_cents' : IDL.Nat,
            'profile' : IDL.Opt(Profile),
          }),
        ],
        ['query'],
      ),
    'community_updates' : IDL.Func(
        [IDL.Nat, IDL.Nat],
        [IDL.Record({ 'total' : IDL.Nat, 'items' : IDL.Vec(Profile) })],
        ['query'],
      ),
    'community_updates_v2' : IDL.Func(
        [IDL.Nat, IDL.Nat],
        [IDL.Record({ 'total' : IDL.Nat, 'items' : IDL.Vec(ProfileV2) })],
        ['query'],
      ),
    'community_updates_v3' : IDL.Func(
        [IDL.Nat, IDL.Nat],
        [IDL.Record({ 'total' : IDL.Nat, 'items' : IDL.Vec(ProfileV3) })],
        ['query'],
      ),
    'community_v2' : IDL.Func(
        [IDL.Principal],
        [
          IDL.Record({
            'pending' : IDL.Bool,
            'next_usd_cents' : IDL.Nat,
            'profile' : IDL.Opt(ProfileV2),
          }),
        ],
        ['query'],
      ),
    'community_v3' : IDL.Func(
        [IDL.Principal],
        [
          IDL.Record({
            'pending' : IDL.Bool,
            'next_usd_cents' : IDL.Nat,
            'profile' : IDL.Opt(ProfileV3),
          }),
        ],
        ['query'],
      ),
    'configure_billing' : IDL.Func([Config__1], [Result_2], []),
    'configure_platform_metrics' : IDL.Func([Config], [Result_2], []),
    'configure_reactions' : IDL.Func([ReactionConfigInput], [Result_2], []),
    'configure_screener_market' : IDL.Func([IDL.Principal], [Result_2], []),
    'create_reaction_quote' : IDL.Func(
        [IDL.Principal, ReactionKind],
        [Result_3],
        [],
      ),
    'favourites' : IDL.Func([], [IDL.Vec(IDL.Principal)], ['query']),
    'feature_requests' : IDL.Func([Sort, IDL.Nat, IDL.Nat], [Page], ['query']),
    'has_paid_profile' : IDL.Func([IDL.Principal], [IDL.Bool], ['query']),
    'health' : IDL.Func([], [IDL.Text], ['query']),
    'http_request' : IDL.Func([Request], [Response], ['query']),
    'mining_jobs' : IDL.Func(
        [IDL.Nat, IDL.Nat],
        [IDL.Record({ 'total' : IDL.Nat, 'items' : IDL.Vec(Job__1) })],
        ['query'],
      ),
    'mining_status' : IDL.Func([IDL.Principal], [MarketStatus__1], ['query']),
    'my_pending_updates' : IDL.Func([], [IDL.Vec(Quote)], ['query']),
    'my_pending_updates_v2' : IDL.Func([], [IDL.Vec(QuoteV2)], ['query']),
    'my_pending_updates_v3' : IDL.Func([], [IDL.Vec(QuoteV3)], ['query']),
    'my_quote_banner' : IDL.Func([IDL.Nat64], [IDL.Opt(Image)], ['query']),
    'my_quote_mining' : IDL.Func(
        [IDL.Nat64],
        [IDL.Opt(QuotePolicy__1)],
        ['query'],
      ),
    'my_quote_screener' : IDL.Func(
        [IDL.Nat64],
        [IDL.Opt(QuotePolicy)],
        ['query'],
      ),
    'my_reaction_daily' : IDL.Func([IDL.Principal], [View__2], ['query']),
    'my_reaction_quote' : IDL.Func([], [IDL.Opt(ReactionQuote)], ['query']),
    'my_update' : IDL.Func([IDL.Nat64], [IDL.Opt(Quote)], ['query']),
    'my_update_v2' : IDL.Func([IDL.Nat64], [IDL.Opt(QuoteV2)], ['query']),
    'my_update_v3' : IDL.Func([IDL.Nat64], [IDL.Opt(QuoteV3)], ['query']),
    'pay_reaction' : IDL.Func([IDL.Nat64], [Result_3], []),
    'platform_metrics' : IDL.Func([], [View__1], ['query']),
    'prepare_update' : IDL.Func([IDL.Principal, Fields], [Result_7], []),
    'prepare_update_v2' : IDL.Func([IDL.Principal, FieldsV2], [Result_6], []),
    'prepare_update_v3' : IDL.Func([IDL.Principal, FieldsV3], [Result_5], []),
    'prepare_update_with_banner' : IDL.Func(
        [IDL.Principal, FieldsV3, IDL.Opt(Upload)],
        [Result_5],
        [],
      ),
    'process_mining' : IDL.Func([], [Result_2], []),
    'process_screener' : IDL.Func([], [Result_2], []),
    'profile_status' : IDL.Func([IDL.Principal], [ProfileStatus], ['query']),
    'profile_statuses' : IDL.Func(
        [IDL.Vec(IDL.Principal)],
        [IDL.Vec(ProfileStatus)],
        ['query'],
      ),
    'publish_update' : IDL.Func([IDL.Nat64], [Result_4], []),
    'reaction_config' : IDL.Func([], [ReactionConfig], ['query']),
    'reaction_quote' : IDL.Func(
        [IDL.Nat64],
        [IDL.Opt(ReactionQuote)],
        ['query'],
      ),
    'reaction_totals' : IDL.Func([IDL.Principal], [ReactionTotals], ['query']),
    'reaction_totals_batch' : IDL.Func(
        [IDL.Vec(IDL.Principal)],
        [IDL.Vec(ReactionTotals)],
        ['query'],
      ),
    'reconcile_mining' : IDL.Func([IDL.Nat64], [Result_2], []),
    'reconcile_reaction' : IDL.Func([IDL.Nat64, IDL.Nat], [Result_3], []),
    'reconcile_screener' : IDL.Func([IDL.Nat64], [Result_2], []),
    'reconcile_update' : IDL.Func([IDL.Nat64, IDL.Nat64], [Result_4], []),
    'record_platform_cycles' : IDL.Func([IDL.Vec(CycleReport)], [Result_2], []),
    'recover_reaction' : IDL.Func([IDL.Nat64], [Result_3], []),
    'screener_jobs' : IDL.Func(
        [IDL.Nat, IDL.Nat],
        [IDL.Record({ 'total' : IDL.Nat, 'items' : IDL.Vec(Job) })],
        ['query'],
      ),
    'screener_purchase' : IDL.Func(
        [IDL.Nat64],
        [IDL.Opt(PurchaseIntent)],
        ['query'],
      ),
    'screener_purchase_config' : IDL.Func([], [ConfigView], ['query']),
    'screener_reserve_status' : IDL.Func(
        [IDL.Principal],
        [MarketStatus],
        ['query'],
      ),
    'set_favourite' : IDL.Func([IDL.Principal, IDL.Bool], [Result_2], []),
    'set_feature_upvote' : IDL.Func([IDL.Nat64, IDL.Bool], [Result_1], []),
    'set_screener_purchases_enabled' : IDL.Func([IDL.Bool], [Result_2], []),
    'submit_feature_request' : IDL.Func([IDL.Text, IDL.Text], [Result_1], []),
    'wallet_account' : IDL.Func(
        [IDL.Principal],
        [IDL.Vec(IDL.Nat8)],
        ['query'],
      ),
    'withdraw_fees' : IDL.Func([Account, IDL.Nat, IDL.Nat64], [Result], []),
    'withdrawal_history' : IDL.Func(
        [],
        [
          IDL.Vec(
            IDL.Tuple(
              IDL.Principal,
              IDL.Nat,
              IDL.Nat64,
              IDL.Variant({ 'ok' : IDL.Nat, 'err' : IDL.Text }),
            )
          ),
        ],
        ['query'],
      ),
    'withdrawal_status' : IDL.Func(
        [IDL.Nat64],
        [IDL.Opt(Withdrawal)],
        ['query'],
      ),
  });
};

export const init: (args: { IDL: typeof IDL }) => IDL.Type[] = ({ IDL }) => {
  return [];
};
